import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a418632"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "form-input",
  title: "The new credit score to submit",
  type: "number",
  min: 0,
  max: 2000,
  step: "any",
  placeholder: "New Score",
  required: ""
}, null, -1))
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "body" }

import { Ref, ref, computed, watch } from 'vue';
import Popup from '../Popup.vue';
import GroupedInputButton from '../GroupedInputButton.vue';
import ContractValidation from '@/models/ContractValidation';
import TablePersistentChecking from '../TablePersistentChecking.vue';
import TickCrossBooleanDisplay from '../TickCrossBooleanDisplay.vue';
import { contractValidations, manualCreditScore as manualCreditScoreSvc } from '@/services/network';
import useContractValidation from '@/services/composables/ContractValidation';
import useNotifierWithErrFormatter from '@/services/composables/NotifierWithErrFormatter';
import { INotificationPopupExpose } from '../NotificationPopup.vue';
import { marketSelection } from '@/services/helpers/Helper';
import ExpandableText from "@/components/ExpandableText.vue";
import OverallValidationBooleanDisplay from "@/components/Contracts/OverallValidationBooleanDisplay.vue";
import {ContractValidationType} from '@/models/enums/ContractValidationType';
import { authService } from '@/auth/authSingleton';
import { AuthorisationLevel, GetAuthLevel } from '@/config/AuthConfig';


export default /*#__PURE__*/_defineComponent({
  __name: 'ValidationDataPopup',
  props: {
    modelValue: {},
    hasOverride: { type: Boolean },
    validationType: {}
  },
  emits: ["update:modelValue", "override", "request-update"],
  setup(__props: any, { emit: __emit }) {

const downloadError = ref<INotificationPopupExpose>();
const working = ref(false);
const {
    getFlattened,
    getColKeys,
    getBoolKeys
} = useContractValidation();

const props = __props;
const hasScoreUpdate = computed(()=>(props.validationType === 'UNDERWRITING') && (props.hasOverride || GetAuthLevel(authService.getUsersRole()) === AuthorisationLevel.External));
const validations: Ref<ContractValidation[]|undefined> = ref();
const emits = __emit;
const flattened = computed(()=>validations.value?.map(getFlattened));
const cols = computed(()=>getColKeys(validations.value));
const boolCols = computed(()=>getBoolKeys(validations.value));
function close() {
    emits('update:modelValue');
}
async function downloadValidations(contractID: string) {
    try {
        downloadError.value?.destroy();
        validations.value = undefined;
        validations.value = (await contractValidations.post({
            market: marketSelection.value,
            contractIDs: [contractID],
            includeHistory: true,
            validationType: props.validationType
        }))
            .data
            .contracts[0]
            ?.validations
            ?.map(x => new ContractValidation(x));
    } catch(error) {
        await useNotifierWithErrFormatter().error({ errorType: 'Downloading Validations', error});
    }
}
async function handleNewContractID(contractID?: string) {
    if (contractID) {
        working.value = true;
        await downloadValidations(contractID);
        working.value = false;
    }
}
function onForceValid() {
    if (props.modelValue) emits('override', [props.modelValue], true);
}
function onForceInvalid() {
    if (props.modelValue) emits('override', [props.modelValue], false);
}
async function onSubmitCredit(e: Event) {
    if (working.value) return;
    working.value = true;
    const old = validations.value;
    try {
        const manualCreditScore = ((e.target as HTMLFormElement).children[0].children[0] as HTMLInputElement).valueAsNumber;
        const contractID = props.modelValue;
        if (!contractID) throw new ReferenceError('contractID is unexpectedly undefined');
        const json = {
            username: authService.getEmailAddress(),
            manualCreditScore,
            contractID
        }
        const confirm = window.confirm(
            `Please confirm the credit score update details:\n\n` +
            `Contract ID: ${json.contractID}\n`+
            `Credit Score: ${json.manualCreditScore}\n`
        );
        if (confirm) {
            validations.value = undefined;
            await manualCreditScoreSvc.post(json);
            await useNotifierWithErrFormatter().success({ msg: `Credit score updated for contract ${contractID} to ${manualCreditScore}.` });
            emits('request-update', contractID);
            close();
        }
    } catch(error) {
        await useNotifierWithErrFormatter().error({ errorType: 'Submitting Credit Score', error });
        validations.value = old;
    } finally {
        working.value = false;
    }
}
watch(()=>props.modelValue, handleNewContractID);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    modelValue: !!_ctx.modelValue,
    "onUpdate:modelValue": close,
    style: {"min-height":"40%"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", null, "Validation Results of " + _toDisplayString(_ctx.modelValue), 1),
          (hasScoreUpdate.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                onSubmit: _withModifiers(onSubmitCredit, ["prevent"])
              }, [
                _createVNode(GroupedInputButton, { class: "form-button-group" }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _createElementVNode("button", {
                      class: "form-button",
                      title: "Manually override credit score",
                      disabled: working.value
                    }, "Submit Credit Score", 8, _hoisted_5)
                  ]),
                  _: 1
                })
              ], 40, _hoisted_3))
            : _createCommentVNode("", true),
          (_ctx.hasOverride)
            ? (_openBlock(), _createBlock(GroupedInputButton, {
                key: 1,
                class: "button-group"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "left-btn",
                    title: "Override the validation result to be valid",
                    disabled: working.value,
                    onClick: onForceValid,
                    type: "button"
                  }, " Force Valid ", 8, _hoisted_6),
                  _createElementVNode("button", {
                    title: "Override the validation result to be invalid",
                    onClick: onForceInvalid,
                    disabled: working.value,
                    type: "button"
                  }, " Force Invalid ", 8, _hoisted_7)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(TablePersistentChecking, {
            Rows: flattened.value,
            Cols: cols.value,
            DisableSort: "",
            SplitColKeys: ""
          }, _createSlots({
            validation: _withCtx(({value}) => [
              _createVNode(OverallValidationBooleanDisplay, {
                value: value.validation
              }, null, 8, ["value"])
            ]),
            manualOverride: _withCtx(({value}) => [
              _createVNode(TickCrossBooleanDisplay, {
                value: value.manualOverride
              }, {
                true: _withCtx(() => [
                  _createTextVNode("Y")
                ]),
                false: _withCtx(() => [
                  _createTextVNode("N")
                ]),
                _: 2
              }, 1032, ["value"])
            ]),
            "validation-header": _withCtx(() => [
              _createTextVNode(" Overall Validation ")
            ]),
            ValidationMessage: _withCtx(({value}) => [
              _createVNode(ExpandableText, { maxLines: 3 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(value.ValidationMessage), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, [
            _renderList(boolCols.value, (k) => {
              return {
                name: `${k}`,
                fn: _withCtx(({ value }) => [
                  _createVNode(TickCrossBooleanDisplay, {
                    value: (value[k] as boolean | undefined)
                  }, null, 8, ["value"])
                ])
              }
            })
          ]), 1032, ["Rows", "Cols"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})